import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
/* eslint-disable */


export default /*#__PURE__*/_defineComponent({
  __name: 'ControlDescriptor',
  props: {
  component: {
    type: String,
    default: 'DControlSimpleInput',
  },
  name: String,
  errors: {
    type: Object,
    default: {},
  },
  isSuccess: Boolean,
  inputLabel: String,
  staticLabel: String,
  options: Array,
  labelBy: String,
  type: {
    type: String,
    default: 'text',
  },
  rules: {
    type: String,
    default: '',
  },
  setValue: {},
},
  setup(__props, { expose }) {
  expose();

const props = __props



const inputValue = ref(null)
const r = 'required'

const isRequired = props.rules.includes(r)
const isValid = ref(null)


const updateValue = val => {
  inputValue.value = val
}


const __returned__ = { props, inputValue, r, isRequired, isValid, updateValue, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})